export class AuxRoute {
    /**
     * Whether or not the auxiliary route will load a module.
     */
    isModule: boolean;

    /**
     * Name of the outlet.
     */
    outletName: string;

    /**
     * Name of the route that will be loaded into the outlet.
     */
    routeName: string;

    /**
     * The parameter that is used by the route.
     */
    routeParameter: any[];
}
